var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "authorization" },
    [
      _c("el-card", { staticClass: "box-card" }, [
        _vm.isDelegation
          ? _c(
              "div",
              { staticClass: "logout-wrap" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.logoutDelegateAccount }
                  },
                  [_vm._v(_vm._s(_vm.$t("Tool.BackToMyAccount")))]
                )
              ],
              1
            )
          : _vm._e(),
        !_vm.isDelegation
          ? _c(
              "div",
              { staticClass: "admin-wrap" },
              [
                _c(
                  "div",
                  { staticClass: "admin-wrap-form" },
                  [
                    _c("label", [_vm._v(_vm._s(_vm.$t("Tool.AuthOwned")))]),
                    _vm.isAdmin
                      ? _c("label", [_vm._v(_vm._s(_vm.$t("Tool.AdminUse")))])
                      : _vm._e(),
                    _vm.isAdmin
                      ? _c("cargo-advance-select", {
                          attrs: {
                            filterable: "",
                            "select-type": _vm.selectTypeNames.basic_data_User,
                            "callback-method-type": "obj",
                            "default-value": _vm.vb1.delegator || "",
                            "callback-params": { key: "delegator" }
                          },
                          on: { parentCallBack: _vm.setVb1Delegator }
                        })
                      : _vm._e(),
                    _vm.isAdmin
                      ? _c(
                          "i",
                          {
                            staticClass: "go-btn",
                            on: { click: _vm.goAdminDelegate }
                          },
                          [_vm._v("GO")]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        staticClass: "flush-btn",
                        style:
                          (!_vm.isAdmin ? "margin-left: 10px;" : "") +
                          "width: unset;",
                        attrs: { type: "primary" },
                        on: { click: _vm.refreshVb1Grid }
                      },
                      [_vm._v(_vm._s(_vm.$t("Tool.Refresh")))]
                    )
                  ],
                  1
                ),
                _c("cargo-ag-grid", {
                  attrs: {
                    "grid-options": _vm.vb1.gridOptions,
                    "column-defs": _vm.vb1.columnDefs,
                    "show-side-bar": false,
                    "row-data": _vm.vb1.rowData
                  }
                }),
                !_vm.isAdmin
                  ? _c(
                      "div",
                      { staticClass: "admin-wrap-form" },
                      [
                        _c("label", { staticStyle: { width: "40px" } }, [
                          _vm._v(_vm._s(_vm.$t("Tool.User")))
                        ]),
                        _c("cargo-advance-select", {
                          attrs: {
                            filterable: "",
                            "select-type": _vm.selectTypeNames.basic_data_User,
                            "callback-method-type": "obj",
                            "default-value": _vm.vb2.delegator || ""
                          },
                          on: {
                            parentCallBack: function(p) {
                              return (_vm.vb2.delegator = p.value)
                            }
                          }
                        }),
                        _c("el-date-picker", {
                          staticStyle: {
                            width: "120px",
                            "margin-left": "10px"
                          },
                          attrs: {
                            type: "date",
                            "picker-options": {
                              disabledDate: function(time) {
                                return (
                                  time.getTime() >
                                  new Date(
                                    _vm.vb2.endTime + " 23:59:59"
                                  ).getTime()
                                )
                              }
                            },
                            "value-format": "yyyy-MM-dd"
                          },
                          model: {
                            value: _vm.vb2.startTime,
                            callback: function($$v) {
                              _vm.$set(_vm.vb2, "startTime", $$v)
                            },
                            expression: "vb2.startTime"
                          }
                        }),
                        _vm._v(" " + _vm._s(_vm.$t("SeaExport.To")) + " "),
                        _c("el-date-picker", {
                          staticStyle: { width: "120px" },
                          attrs: {
                            type: "date",
                            "picker-options": {
                              disabledDate: function(time) {
                                return (
                                  time.getTime() <
                                  new Date(
                                    _vm.vb2.startTime + " 00:00:00"
                                  ).getTime()
                                )
                              }
                            },
                            "value-format": "yyyy-MM-dd"
                          },
                          model: {
                            value: _vm.vb2.endTime,
                            callback: function($$v) {
                              _vm.$set(_vm.vb2, "endTime", $$v)
                            },
                            expression: "vb2.endTime"
                          }
                        }),
                        _c(
                          "el-button",
                          {
                            staticClass: "flush-btn",
                            staticStyle: { "margin-left": "10px" },
                            attrs: { type: "primary" },
                            on: { click: _vm.onAddVb2 }
                          },
                          [_vm._v(_vm._s(_vm.$t("Tool.NewAuth")))]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.isAdmin
                  ? _c("cargo-ag-grid", {
                      attrs: {
                        "grid-options": _vm.vb2.gridOptions,
                        "column-defs": _vm.vb2ColumnDefs,
                        "show-side-bar": false,
                        "row-data": _vm.vb2.rowData
                      },
                      on: {
                        gridReady: function(params) {
                          _vm.vb2.gridApi = params.api
                        }
                      }
                    })
                  : _vm._e(),
                !_vm.isAdmin
                  ? _c(
                      "div",
                      { staticClass: "admin-wrap-form" },
                      [
                        _c("label", { staticStyle: { width: "100px" } }, [
                          _vm._v(_vm._s(_vm.$t("Tool.AuthHistory")))
                        ]),
                        _c("el-input", {
                          staticStyle: { width: "150px" },
                          on: { input: _vm.updateDelegationLog },
                          model: {
                            value: _vm.vb3.filterStr,
                            callback: function($$v) {
                              _vm.$set(_vm.vb3, "filterStr", $$v)
                            },
                            expression: "vb3.filterStr"
                          }
                        }),
                        _c(
                          "el-button",
                          {
                            staticClass: "flush-btn",
                            staticStyle: { "margin-left": "10px" },
                            attrs: { type: "primary" },
                            on: { click: _vm.onShowAllLog }
                          },
                          [_vm._v(_vm._s(_vm.$t("Tool.Refresh")))]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.isAdmin
                  ? _c("cargo-ag-grid", {
                      attrs: {
                        "grid-options": _vm.vb3.gridOptions,
                        "column-defs": _vm.vb3ColumnDefs,
                        "show-side-bar": false,
                        "row-data": _vm.vb3.rowData
                      },
                      on: {
                        gridReady: function(params) {
                          _vm.vb3.gridApi = params.api
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e()
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.remarkView.visible,
            title: _vm.$t("Tool.ConfirmAuth"),
            width: "400px",
            "custom-class": "cargo-form-dialog",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: { close: _vm.handleClose }
        },
        [
          _c("div", [
            _c("span", [_vm._v(_vm._s(_vm.$t("Tool.InputAuthReason") + ":"))]),
            _c(
              "span",
              { staticStyle: { "margin-top": "10px" } },
              [
                _c("el-input", {
                  attrs: { type: "textarea", rows: 10 },
                  model: {
                    value: _vm.remarkView.remark,
                    callback: function($$v) {
                      _vm.$set(_vm.remarkView, "remark", $$v)
                    },
                    expression: "remarkView.remark"
                  }
                })
              ],
              1
            )
          ]),
          _c(
            "span",
            {
              staticStyle: { padding: "10px" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Confirm")))]
              ),
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.Cancel")))
              ])
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }